import { CmsActivityContainerModel } from '../../../../../../models/aggregates/cms/activity/cms-activity-container.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CmsActivityService extends BaseApiPublicLoginTemplateService<CmsActivityContainerModel, CmsActivityContainerModel, CmsActivityContainerModel> {

    static readonly ACTIVITY_SUB_PATH = 'activities/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityService.ACTIVITY_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityService.ACTIVITY_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityService.ACTIVITY_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP
        this.httpClient = http;
    }

    postWithFileUpload(dtoObject: CmsActivityContainerModel, file: File, visa: ApiVisa): Observable<ApiResponseModel<CmsActivityContainerModel>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }

      const formData = new FormData();
      formData.append('activity_image', file);
      formData.append('data', new Blob([JSON.stringify(dtoObject)], { type: 'application/json' }));

      return this.httpClient.post<ApiResponseModel<CmsActivityContainerModel>>(
        this.apiUrl,
        formData,
        this.getHttpHeader(visa)
      );
    }

}
